import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'formatadorDistancia'
})
export class FormatadorDistanciaPipe implements PipeTransform {
  constructor() {

  }

  transform(value: any, ...args: any[]) {
    if (value == null || isNaN(value)) return '';

    if (value >= 1000) {
      const km = value / 1000;
      return `${km.toFixed(1)} km`;
    }
    
    return `${value.toFixed(0)} m`;
  }
}